import { Check, Loader2, Save } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { brl, type KitItem, type OrcamentoResultado } from './calc';
import { Row } from './ui';
import { linkBtnCls } from './styles';

/** Resumo fixo ao lado de todos os passos: o total atualiza a cada mudança. */
export function ResumoLateral({
  clienteNome,
  local,
  itens,
  resultado,
  softwarePlano,
  softwareMensal,
  softwareMeses,
  salvando,
  salvoOk,
  editando,
  podeSalvar,
  onSalvar,
  onNovo,
}: {
  clienteNome: string;
  local: string;
  itens: KitItem[];
  resultado: OrcamentoResultado;
  softwarePlano: string;
  softwareMensal: number;
  softwareMeses: number;
  salvando: boolean;
  salvoOk: boolean;
  editando: boolean;
  podeSalvar: boolean;
  onSalvar: () => void;
  onNovo: () => void;
}) {
  return (
    <aside className="rounded-lg border border-border bg-card p-5 lg:sticky lg:top-4">
      <div className="mb-4">
        <p className="text-sm font-semibold text-text-title">
          {clienteNome || <span className="font-normal text-text-secondary">Cliente sem nome</span>}
        </p>
        {local && <p className="text-xs text-text-secondary">{local}</p>}
      </div>

      {itens.length === 0 ? (
        <p className="py-2 text-sm text-text-secondary">Nenhum item no kit ainda.</p>
      ) : (
        <ul className="mb-3 space-y-1">
          {itens.map((k) => (
            <li key={k.produto.id} className="flex animate-rise justify-between gap-3 text-sm">
              <span className="truncate text-text-body">{k.produto.nome}</span>
              <span className="shrink-0 text-text-secondary">
                {k.quantidade.toLocaleString('pt-BR')} un
              </span>
            </li>
          ))}
        </ul>
      )}

      <div className="border-t border-border pt-2">
        {resultado.hardwareVenda > 0 && (
          <Row label="Equipamentos" value={brl(resultado.hardwareVenda)} />
        )}
        {resultado.brincoQtd > 0 && <Row label="Brincos" value={brl(resultado.brincoLiquido)} />}
        <Row
          label="Frete"
          value={resultado.freteNacional > 0 ? brl(resultado.freteNacional) : 'a definir'}
          muted={resultado.freteNacional === 0}
        />
      </div>

      <div className="mt-3 rounded-md bg-muted px-3 py-3">
        <p className="text-xs text-text-secondary">Total do kit, à vista</p>
        <p
          key={resultado.totalGeral}
          className="animate-rise text-3xl font-bold tracking-tight text-text-title"
        >
          {brl(resultado.totalGeral)}
        </p>
        {softwareMensal > 0 && (
          <p className="mt-1 text-sm text-text-secondary">
            + {softwarePlano}, {brl(softwareMensal)}/mês por {softwareMeses} meses
          </p>
        )}
      </div>

      <Button
        variant="secondary"
        className="mt-5 w-full"
        onClick={onSalvar}
        disabled={!podeSalvar || salvando}
      >
        {salvando ? (
          <Loader2 size={16} className="animate-spin" />
        ) : salvoOk ? (
          <Check size={16} />
        ) : (
          <Save size={16} />
        )}
        {salvoOk ? 'Salvo' : editando ? 'Salvar alterações' : 'Salvar rascunho'}
      </Button>
      {(editando || podeSalvar) && (
        <button
          type="button"
          className={`${linkBtnCls} mt-3 block w-full text-center`}
          onClick={onNovo}
        >
          Começar um orçamento novo
        </button>
      )}
    </aside>
  );
}
